<div class="content-wrapper">
    @if(!loading) {
    @if(linkExpired) {
    <p>The link you clicked has expired.</p>
    }
    } @else {
    <app-cf-loader>
        <p>Contacting server. Please wait...</p>
    </app-cf-loader>
    }
</div>